import { useCallback, useMemo } from "react";
import Select from "../../../../components/shared/inputs/Select";
import { getCommonProperty } from "../../../TraxxionSchedule/Component/helpers/form/getCommonProperty";
import { renderSettingsResourceLabel } from "../../../../utils/helpers/settings";
import { cn } from "../../../../lib/utils";

/** Select over one of the user's own resources (jobs, locations), keeping the saved value selectable. */
function ObjectSelect({ user, property, idProperty, fields, value, onChange, placeholder, disabled, className }) {
    const options = useMemo(() => {
        const items = user ? getCommonProperty(user, property, idProperty, fields) : [];
        return value?.code && !items.find((item) => item.code === value.code)
            ? [...items, value]
            : items;
    }, [user, property, idProperty, fields, value]);

    const onSelectChange = useCallback((code) => {
        onChange?.(options.find((item) => item.code === code));
    }, [options, onChange]);

    return (
        <Select
            className={cn("tw-w-full", className)}
            placeholder={placeholder}
            disabled={disabled}
            value={value?.code}
            onChange={onSelectChange}
        >
            {options.map((item) => (
                <Select.Item key={item.code} value={item.code}>
                    {renderSettingsResourceLabel(item)}
                </Select.Item>
            ))}
        </Select>
    );
}

const jobFields = ["id", "code", "description", "jobId", "hourlyRate"];
const locationFields = ["id", "code", "description", "timezoneId", "timezoneValue", "locationId"];

export const JobSelect = (props) => (
    <ObjectSelect property="jobs" idProperty="jobId" fields={jobFields} {...props} />
);

export const LocationSelect = (props) => (
    <ObjectSelect property="locations" idProperty="locationId" fields={locationFields} {...props} />
);
